import type React from 'react';

export const PassThrough = ({ children }: React.PropsWithChildren): React.ReactNode => children;
